<app-key-combo-button
  icon="fas fa-search"
  [outlined]="false"
  size="small"
  label=""
  [keys]="['control', '.']"
  styleClass="p-button-shade"
  (action)="visible = true"></app-key-combo-button>

<p-dialog
  header="Header"
  (onShow)="search()"
  [(visible)]="visible"
  [modal]="true"
  position="top"
  [draggable]="false"
  [blockScroll]="true"
  styleClass="overflow-hidden"
  [style]="{ width: '80rem', 'max-height': '90vh' }">
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3 w-full">
      <app-search-input
        [autofocus]="true"
        inputStyleClass="w-15rem"
        [searchValue]="queryString"
        placeholder="durchsuchen ..."
        (search)="updateQueryString($event)"></app-search-input>
      <app-tag-filter-dropdown
        styleClass="w-20rem"
        (selectedTagsChange)="updateQueryTags($event)"
        [selectedTags]="queryTags"
        [tagsInUse]="globalSearchStore.tagsInUse()" />
      @if (tree) {
        <p-iconField>
          <p-inputIcon styleClass="fas fa-folder"></p-inputIcon>
          <p-treeSelect
            class="w-20rem"
            placeholder="Indikatoren durchsuchen ..."
            containerStyleClass="w-full"
            [(ngModel)]="queryCategory"
            (onNodeSelect)="callCategorySearch($event)"
            (onClear)="callCategorySearch()"
            [resetFilterOnHide]="true"
            [showClear]="true"
            [filter]="true"
            [options]="tree">
          </p-treeSelect>
        </p-iconField>
      }
      <p-button
        class="ml-auto mr-3"
        [disabled]="!queryString && !queryTags.length && !queryCategory"
        icon="fas fa-filter-circle-xmark"
        [rounded]="true"
        [outlined]="true"
        (click)="resetQuery()"
        label="zurücksetzen"></p-button>
    </div>
  </ng-template>
  @if (results) {
    <div class="flex w-full flex-1 gap-3 flex-wrap overflow-hidden">
      <div class="flex-shrink-0">
        <p-menu [model]="tabs" styleClass="w-15rem p-card p-0">
          <ng-template pTemplate="item" let-item>
            <a
              pRipple
              [ngClass]="{
                'p-menuitem-link-active': item.key === active,
                'p-disabled': !results[item.key].length,
                'border-bottom-1': item !== tabs[tabs.length - 1],
              }"
              class="flex align-items-center gap-2 p-menuitem-link surface-border">
              <i
                class="text-center"
                style="width: 1.5rem"
                [class]="item.icon"></i>
              <span class="font-semibold"> {{ item.label }} </span>
              <p-badge class="ml-auto" [value]="results[item.key].length" />
            </a>
          </ng-template>
        </p-menu>
      </div>
      <div class="flex-grow-1 flex flex-1 flex-column overflow-hidden h-full">
        <p-tabMenu
          hidden
          [scrollable]="true"
          [model]="tabs"
          [activeItem]="activeTab"
          (activeItemChange)="onActiveItemChange($event)">
          <ng-template pTemplate="item" let-item>
            <a
              pRipple
              [ngClass]="{
                'p-disabled': !results[item.key].length,
              }"
              class="flex align-items-center gap-2 p-menuitem-link">
              <i [class]="item.icon"></i>
              <span class="font-bold">
                {{ item.label }}
              </span>
              <p-badge [value]="results[item.key].length" />
            </a>
          </ng-template>
        </p-tabMenu>
        <div class="flex-1 overflow-y-auto">
          @if (
            indicatorSelection &&
            indicatorSelection.length &&
            active === 'indicators'
          ) {
            <div class="p-card p-3 my-3">
              <app-indicator-selection-list
                [indicatorIds]="indicatorSelection"
                (unselectEvent)="removeFromSelection($event)" />
              <p-divider />
              <footer class="flex justify-content-end gap-3">
                <a
                  pButton
                  (click)="resetFromSelection()"
                  [text]="true"
                  [rounded]="true"
                  icon="fas fa-trash"
                  label="Auswahl aufheben"></a>
                <a
                  pButton
                  (click)="initViewDialog()"
                  [text]="true"
                  [rounded]="true"
                  icon="fas fa-eye"
                  label="Im Atlas anzeigen"></a>
              </footer>
            </div>
          }
          @if (active && results[active] && results[active].length) {
            <p-table
              [value]="results[active]"
              [paginator]="results[active].length > 8"
              [rows]="8"
              [tableStyle]="{ 'min-width': '50rem' }"
              [alwaysShowPaginator]="false">
              <ng-template pTemplate="body" let-item>
                <tr
                  *ngIf="
                    !indicatorSelection.includes(item._id) &&
                    isType('indicator', item._id)
                  "
                  app-table-row-indicator
                  [item]="item"
                  [fullName]="true"
                  [actions]="
                    hasDataWidgets
                      ? ['info', 'generateView', 'addToAtlas', 'addToSelection']
                      : ['info', 'generateView', 'addToSelection']
                  "
                  (generateViewEvent)="initViewDialog($event)"
                  (addToSelectionEvent)="addToSelection($event)"
                  (addToWidgetsEvent)="addToWidgets($event)"></tr>
                <tr
                  *ngIf="isType('dataLayerType', item._id)"
                  app-table-row-data-layer-type
                  [actions]="['generateView']"
                  [item]="item"
                  (generateViewEvent)="initViewDialog(undefined, $event)"
                  (closeEvent)="close()"></tr>
                <tr
                  *ngIf="isType('poiLayerType', item._id)"
                  app-table-row-data-layer-type
                  [actions]="['generateView', 'addPoi']"
                  [item]="item"
                  (generateViewEvent)="
                    initViewDialog(undefined, $event, undefined, $event._id)
                  "
                  (closeEvent)="close()"></tr>
                <tr
                  *ngIf="isType('bookmark', item._id)"
                  app-table-row-bookmark
                  [actions]="['openInAtlas']"
                  [item]="item"
                  (closeEvent)="close()"></tr>
                <tr
                  *ngIf="isType('topic', item._id)"
                  app-table-row-topic
                  [actions]="['openInAtlas']"
                  [item]="item"
                  (closeEvent)="close()"></tr>
                <tr
                  *ngIf="isType('story', item._id)"
                  app-table-row-story
                  [actions]="['openInAtlas']"
                  [item]="item"
                  (closeEvent)="close()"></tr>
                <tr
                  *ngIf="isType('district', item.geoData)"
                  app-table-row-district
                  [item]="item"
                  (generateViewEvent)="
                    initViewDialog(undefined, $event, item.key)
                  "
                  (closeEvent)="close()"></tr>
                <tr
                  *ngIf="isType('poi', item.geoData)"
                  app-table-row-district
                  (generateViewEvent)="
                    initViewDialog(undefined, undefined, undefined, $event._id)
                  "
                  [item]="item"
                  (closeEvent)="close()"></tr>
              </ng-template>
            </p-table>
          } @else if (results[active].length === 0 && active === 'all') {
            <div
              (click)="setFocus()"
              class="w-full h-full flex flex-column gap-6 justify-content-center align-items-center text-color-secondary">
              <i
                class="cursor-pointer transition-all transition-linear transition-duration-300 text-6xl fas fa-arrow-circle-up hover:text-400"></i>
              <div class="text-xl w-7 text-center">
                Nutzen Sie die Suchfunktion oben, um Indikatoren, Ansichten,
                Berichte und Teilräume zu finden und diese Ihrem Dashboard
                hinzuzufügen.
              </div>
            </div>
          } @else if (results[active].length === 0 && active === 'all') {
            <app-alert
              severity="secondary"
              styleClass="p-3"
              [canToggle]="false">
              <i>Wir konnten zu Ihrer Auswahl keine Inhalte finden.</i>
            </app-alert>
          }
        </div>
      </div>
    </div>
  } @else {
    <app-alert [canToggle]="false">
      Suchen Sie nach Indikatoren, Ansichten, Berichte oder Teilräume und fügen
      Sie diese zum Dashboard hinzu.
    </app-alert>
  }

  <ng-template pTemplate="footer">
    <p-button
      class="mr-auto flex"
      icon="fas fa-times"
      [rounded]="true"
      [outlined]="true"
      label="schließen"
      severity="secondary"
      (onClick)="close()" />
  </ng-template>
</p-dialog>
<p-dialog [(visible)]="showGenerateViewDialog" [modal]="true">
  <ng-template pTemplate="headless">
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-wand-magic-sparkles"
        text="Automatische Ansicht generieren"></app-header>

      @if (
        showGenerateViewMode === 'indicator' &&
          indicatorStore.getById(indicatorSelection.at(0) || '');
        as indicator
      ) {
        <p class="flex">
          In welchem Raum wollen Sie "{{
            indicatorStore.getFullName(indicator, false)
          }}" anzeigen?
        </p>
        <app-type-dropdown
          mode="all"
          [withIndicators]="[indicator._id]"
          [displayNewLayerTypeOption]="false"
          [(ngModel)]="dataLayerTypeToGenerateView"></app-type-dropdown>
      } @else {
        <p class="flex">
          Welche Indikatoren wollen Sie in "{{
            dataLayerTypeToGenerateView?.name
          }}" anzeigen?
        </p>
        <p-scrollPanel [style]="{ width: '100%', height: '20rem' }">
          <app-atlas-indicator-tree
            [withDataInType]="dataLayerTypeToGenerateView?._id"
            [selection]="indicatorSelection"
            (selectIndicator)="addToSelection($event)" />
        </p-scrollPanel>
      }
      @if (generatePoiDataView) {
        <div class="flex my-4">
          <p-button
            class="ml-auto"
            size="small"
            [rounded]="true"
            [text]="true"
            icon="fas fa-map-location-dot"
            label="Standorte ohne Daten anzeigen"
            (click)="generateNoneDataView(generatePoiDataView)">
          </p-button>
        </div>
        <p-divider></p-divider>
      }
      <div class="text-sm text-color-secondary">
        <i class="fas fa-warning"></i> Ihre aktuelle Ansicht wird überschrieben
      </div>
      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="closeAtlasDialog()"></button>
        <button
          [rounded]="true"
          [disabled]="!dataLayerTypeToGenerateView"
          pButton
          icon="fas fa-check"
          label="ja, übertragen"
          (click)="generateView()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
